import { INQUIRY_ASSIGN_STATUSES } from 'shared'

/**
 * 全アサインのステータスから引合ステータスの推奨値を算出する。
 * ガード（引合が完了ステータス・現状と同一など）は呼び出し側で行う。
 *
 * 提案ルール:
 * - アサインが0件 → null
 * - アサインが2件以上で全員「確定」→「確定」を提案
 *   （1件のみ確定の場合は次のルールで「調整中」になる）
 * - 1件以上の「調整中」or「確定」あり →「調整中」を提案
 * - 上記以外（全員「探し中」or「取り下げ」）→ null
 */
export function evaluateInquiryStatus(assignStatusIds: number[]): number | null {
  if (assignStatusIds.length === 0) return null

  const allConfirmed = assignStatusIds.every((id) => id === INQUIRY_ASSIGN_STATUSES.CONFIRMED)
  if (allConfirmed && assignStatusIds.length >= 2) return INQUIRY_ASSIGN_STATUSES.CONFIRMED

  const hasAdjustingOrConfirmed = assignStatusIds.some(
    (id) => id === INQUIRY_ASSIGN_STATUSES.ADJUSTING || id === INQUIRY_ASSIGN_STATUSES.CONFIRMED,
  )
  if (hasAdjustingOrConfirmed) return INQUIRY_ASSIGN_STATUSES.ADJUSTING

  return null
}
